import { ERROR_CODE_REPORT, ERROR_CODE_REPORT_FAIL, ERROR_CODE_REPORT_SUCCESS } from 'actions/dataReport';

const initialState = {
  isLoading: false,
  errorCodeReport: [],
  summary: [],
  page: 1,
  limit: 10,
  totalPages: 1,
  totalResults: 0,
};

const errorCodeReportReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case ERROR_CODE_REPORT: {
      return { ...state, isLoading: true };
    }
    case ERROR_CODE_REPORT_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        errorCodeReport: payload?.results,
        summary: payload?.summary,
        page: payload?.page,
        limit: payload?.limit,
        totalPages: payload?.totalPages,
        totalResults: payload?.totalResults,
      };
    }
    case ERROR_CODE_REPORT_FAIL: {
      return { ...state, isLoading: false };
    }
    default:
      return { ...state };
  }
};

export default errorCodeReportReducer;
